import { useEffect, useState } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { ACTIVE_URL } from "@/constants";

// Slug shared by the PageContent (heading) and PageImage (photo) rows
// backing this section; seeded by migration 0023_seed_nova_featured_offer.
const SLUG = "nova-featured-offer";

export function NovaFeaturedOffer() {
  const { ref, visible } = useScrollReveal(0.1);
  const [heading, setHeading] = useState<string | null>(null);
  const [headingHtml, setHeadingHtml] = useState<string | null>(null);
  const [image, setImage] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${ACTIVE_URL}/api/content/${SLUG}/`)
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!cancelled && data) {
          if (data.title) setHeading(data.title);
          if (data.content) setHeadingHtml(data.content);
        }
      })
      .catch(() => {});
    fetch(`${ACTIVE_URL}/api/page-image/${SLUG}/`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (!cancelled && data?.image_url) setImage(data.image_url); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="max-w-[1200px] mx-auto px-6 pb-20">
      <div
        ref={ref}
        className="relative rounded-3xl border border-[#00d9d9]/20 bg-gradient-to-br from-[#00d9d9]/10 to-transparent overflow-hidden p-8 lg:p-12 flex flex-col lg:flex-row items-center gap-8 transition-all duration-700"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(36px)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#00d9d9]/5 to-transparent pointer-events-none" />
        <div className="relative z-10 flex-1 text-center lg:text-left">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-[#00d9d9] mb-3">Αποκλειστική Προσφορά</span>
          {headingHtml ? (
            <h2
              className="text-2xl lg:text-3xl font-bold text-white mb-3 leading-snug max-w-2xl mx-auto lg:mx-0"
              dangerouslySetInnerHTML={{ __html: headingHtml }}
            />
          ) : heading && (
            <h2 className="text-2xl lg:text-3xl font-bold text-white mb-3 leading-snug max-w-2xl mx-auto lg:mx-0">
              {heading}
            </h2>
          )}
          <p className="text-white/60 leading-relaxed max-w-lg">
            Σύνδεσε τον λογαριασμό σου και διεκδίκησε αυτόματα την αποκλειστική προσφορά.
            Μόνο για συνδρομητές Nova μέσω PADU.
          </p>
        </div>
        {image && (
          <img src={image} alt="PADU x Pizza Fan" className="relative z-10 w-48 object-cover shrink-0 rounded-xl" />
        )}
      </div>
    </section>
  );
}
